// telas/TextoGerado.tsx - O texto que a IA devolve, sem as marcas de markdown à mostra (entrega 1.6).
//
// A geração não muda (F10, D25) e às vezes marca trechos com **negrito**. Na tela e no PDF, o trecho vira
// negrito de verdade; no WhatsApp, vira o negrito do próprio WhatsApp (*assim*); onde não cabe negrito
// (títulos), as marcas saem. Nada é interpretado como HTML.

import { Fragment } from 'react';

const NEGRITO = /\*\*(.+?)\*\*/g;

export function TextoGerado({ texto }: { texto: string }) {
  const partes = texto.split(NEGRITO);
  // split com grupo: as posições ímpares são os trechos que estavam entre ** e **.
  return <>{partes.map((p, i) => (i % 2 ? <strong key={i}>{p}</strong> : <Fragment key={i}>{p}</Fragment>))}</>;
}

export function semMarcas(texto: string) {
  return texto.replace(NEGRITO, '$1');
}

export function paraWhatsapp(texto: string) {
  return texto.replace(NEGRITO, '*$1*');
}
